/* eslint-disable no-unused-expressions */										  
import React, { useEffect, useMemo, useReducer } from "react";
import { Box } from "./ui-controls";
import Logger from "../utils/Logger";


//----------------------------------------------------------------------------- LogView
export default function LogView(props){
	const [, render] = useReducer(e => !e);

	const logger = useMemo(e => {
		return props.logger || new Logger(props.path, {useLogList:true})
	}, [])


	useEffect(() => {
		logger.onLog = render

		return () => {
			logger.onLog = null
		}
	}, [])

	
	return (
		<Box>
			{props.children}
			<div className='ui2-log-view'>
				{logger.logList.map((e, i) => <div className='ui2-log-row' key={i}>{e}</div>)} 
			</div>
		</Box>
	)
}
